import { render, staticRenderFns } from "./BarChart.vue?vue&type=template&id=42e9e4ac"
import script from "./BarChart.vue?vue&type=script&lang=ts&setup=true"
export * from "./BarChart.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports